import {
  EstimationMethodType,
  NetworkCalculatorId,
  NetworkMeasurementType,
} from "@validereinc/domain";

export const getMeasurementTypeFromNetworkCalculatorEstimationMethod = (
  estimationMethod: EstimationMethodType
) => {
  switch (estimationMethod.analytics_calculator_id) {
    case NetworkCalculatorId.volume:
      return NetworkMeasurementType.volume;
    case NetworkCalculatorId.mass:
      return NetworkMeasurementType.mass;
    case NetworkCalculatorId.energy:
      return NetworkMeasurementType.energy;
    default:
      return NetworkMeasurementType.volume;
  }
};
